export default "__VITE_ASSET__Dkg7CP0g__";